/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgDriveable56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='#000'
        fillRule='evenodd'
        d='M28 21.5a6 6 0 100 12 6 6 0 000-12zm-4.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z'
      />
      <path
        fill='#000'
        fillRule='evenodd'
        d='M28 6.25C15.988 6.25 6.25 15.988 6.25 28S15.988 49.75 28 49.75 49.75 40.012 49.75 28 40.012 6.25 28 6.25zM7.75 28c0-1.079.084-2.138.247-3.172l10.62-4.685a22.25 22.25 0 018.981-1.893h.804c3.093 0 6.151.645 8.98 1.893l10.621 4.685a20.405 20.405 0 01-.14 7.133l-4.312-.838c-6.636-1.29-12.801 3.792-12.801 10.552v6.39a20.433 20.433 0 01-5.5 0v-6.39c0-6.76-6.165-11.842-12.801-10.552l-4.312.838A20.35 20.35 0 017.75 28zm10.262-9.23l-9.647 4.256C10.582 14.247 18.532 7.75 28 7.75c9.468 0 17.418 6.497 19.635 15.276l-9.647-4.255a23.75 23.75 0 00-9.586-2.021h-.804a23.75 23.75 0 00-9.586 2.02zm25.253 13.825l4.251.826c-1.999 7.212-7.888 12.806-15.266 14.382v-6.128c0-5.817 5.305-10.19 11.015-9.08zm-19.515 9.08v6.128c-7.378-1.575-13.267-7.17-15.266-14.382l4.251-.826c5.71-1.11 11.015 3.263 11.015 9.08z'
      />
      <path
        fill='#000'
        fillRule='evenodd'
        d='M28 1C13.088 1 1 13.088 1 28s12.088 27 27 27 27-12.088 27-27S42.912 1 28 1zM2.5 28C2.5 13.917 13.917 2.5 28 2.5S53.5 13.917 53.5 28 42.083 53.5 28 53.5 2.5 42.083 2.5 28z'
      />
    </svg>
  );
}

export default SvgDriveable56;
